var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.workspace && _vm.currentPage && _vm.builder)?_c('PageTemplateContent',{attrs:{"workspace":_vm.workspace,"builder":_vm.builder,"current-page":_vm.currentPage,"mode":_vm.mode}}):_c('PageSkeleton')
}
var staticRenderFns = []

export { render, staticRenderFns }